"use strict";

(function () {
  'use strict';

  angular.module('lr.Map', ['lr.Utils']);
})();